export default __webpack_public_path__ + "static/media/edit.397b6511.svg";